import React from "react";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

export const MenuCategories = {
  admin: {
    id: 'admin',
    name: 'مدیریت',
    icon: <VerifiedUserIcon />,
  },
  
  paybill: {
    id: 'paybill',
    name: 'فیش حقوق',
    icon: <MonetizationOnIcon />,
  },
  

}

export const MenuIsOpenState = {
  adminUsers: false,
  paybill:true,
}
